import { Injectable } from '@angular/core';
import { catchError, map, Observable, of, take, tap } from 'rxjs';
import { CountryModel, CountryQueryModel, CountryService } from 'infrastructure-shared';
import { HvlConfigurationService } from '@hvlng/framework-bff/core';

@Injectable({
    providedIn: 'root',
})
export class GeneralConfigService {

    private cachedCountry: CountryModel;

    constructor(private countryService: CountryService,
                private configurationService: HvlConfigurationService) {
    }

    getDefaultCountry(): Observable<CountryModel> {
        const countryCode = this.configurationService.config['defaultCountryCode']; //TODO: dil ve currency gibi settings ekranında kaydedilen yerden alınmalı
        if (this.cachedCountry && countryCode == this.cachedCountry?.isoCode2) {
            return of(this.cachedCountry).pipe(take(1));
        }

        let qm = new CountryQueryModel();
        if (!countryCode) {
            qm.isoCode2 = 'TR';
        } else
            qm.isoCode2 = countryCode;

        return this.countryService.queryList(qm)
            .pipe(map(result => result?.[0]),
                tap((country) => this.cachedCountry = country),
                catchError(() => of(null)));
    }


}
